import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import AudioRecorder from 'vue-audio-recorder'

Vue.use(AudioRecorder)

Vue.config.productionTip = false

store.dispatch('tenant/configureAmplify').then(cfg => {
  const app = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

  if (cfg) {
    Object.assign(app.$vuetify.theme, cfg.theme)
  }
})
